<template>
    <div>
        <header>
            <div class="header-title">
                <p>数字证书管理</p>
            </div>
            <div class="header-search">
                <el-input class="header-search-input" v-model="inputValue" clearable placeholder="请输入"></el-input><button @click="serachData()">搜索</button>
            </div>
        </header>
        <main>
            <div class="card-item">
                <div class="card-title">
                    <span>统一社会信用代码：{{informationData.mainCode || informationData.idCard}}</span>
                    <span>主体名称：{{informationData.mainName || informationData.manName}}</span>
                </div>
                <div class="card-content">
                    <div class="card-content-allBox">
                        <div v-for="(item,index) in mainList" :key="index" class="card-content-box" :style="{'opacity': (item.status == 1 ? '1' : '0.5')}">
                            <div class="card-content-box-top">
                                <div class="card-content-box-top-left">
                                    <div class="svg">
                                        <svg t="1624237895869" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1087" width="32" height="32"><path d="M513.28 85.845333L510.293333 85.333333v0.512L149.333333 185.216l20.906667 396.885333c0 2.602667 0 52.821333 15.445333 82.816 77.653333 151.637333 261.333333 243.754667 320.597334 271.146667 0 0 1.962667 1.066667 3.456 1.578667V938.666667c0.512 0 1.024-0.512 1.493333-0.512 0.512 0 1.536 0.512 1.536 0.512v-1.024c1.493333-0.512 2.474667-1.578667 2.986667-1.578667 58.709333-27.392 242.901333-119.509333 320.597333-271.146667 15.402667-29.994667 16.896-80.213333 16.896-82.773333L874.666667 185.173333l-361.386667-99.370666zM297.642667 706.816V244.736h413.696v208.512a152.362667 152.362667 0 0 0-41.301334-17.066667V285.098667H336.512v378.794666h167.765333c8.490667 16.554667 19.925333 31.018667 33.877334 42.922667H297.685333z m188.16-110.208h-92.586667v-40.362667h95.573333c-1.962667 10.368-2.986667 21.205333-2.986666 32.085334a23.082667 23.082667 0 0 0 0 8.277333zM393.258667 486.4v-40.362667h180.224a146.773333 146.773333 0 0 0-51.285334 40.362667H393.258667z m0-110.250667V335.786667h229.973333v40.362666h-229.973333z m243.925333 349.866667c-72.149333 0-130.901333-61.098667-130.901333-136.106667 0-75.093333 58.752-136.106667 130.901333-136.106666 72.192 0 130.986667 61.013333 130.986667 136.106666 0 75.008-58.794667 136.106667-130.986667 136.106667z m0-235.989333c-52.736 0-95.573333 44.501333-95.573333 99.328 0 54.869333 42.837333 99.370667 95.573333 99.370666 52.778667 0 95.573333-44.501333 95.573333-99.370666 0-54.826667-42.794667-99.328-95.573333-99.328z m44.8 153.173333l-18.901333-8.277333-7.978667 19.626666-17.408-42.922666-16.938667 42.922666-7.936-19.626666-18.944 8.277333 15.957334-39.850667-21.418667-36.736 24.874667-42.965333h49.792l24.917333 42.965333-21.930667 37.76 15.957334 38.826667z" p-id="1088" fill="#FFFFFF"></path></svg>
                                    </div>
                            </div>
                                <div class="card-content-box-top-right">
                                    <p class="certificate">证书编号</p>
                                    <p class="certificate-code">{{item.caCode}}</p>
                                </div>
                            </div>
                            <div class="card-content-box-body">
                                <div><span class="title-left">CA厂商</span><span class="title-right">{{item.caAgency}}</span></div>
                                <div><span class="title-left">有效期始</span><span class="title-right">{{item.fromDate}}</span></div>
                                <div><span class="title-left">有效期止</span><span class="title-right">{{item.expireDate}}</span></div>
                                <div><span class="title-left">最近登录时间</span><span class="title-right">{{item.lastLoginTime}}</span></div>
                                <div v-if="item.status == 0"><span class="title-left">状态</span><span class="title-right-status-false">禁用</span></div>
                                <div v-if="item.status == 1"><span class="title-left">状态</span><span class="title-right-status-true">正常</span></div>
                                <div v-if="item.status == 2"><span class="title-left">状态</span><span class="title-right-status-false">过期</span></div>
                            </div>
                            <div v-if="item.status == 0" class="card-content-box-footer"
                                 style="background:rgba(24, 144, 255, 0.1);color:#1890FF"
                                 @click="action(item)">
                                启动
                            </div>
                            <div v-if="item.status == 1" class="card-content-box-footer"
                                 style="background:#F7F7F7;color:rgba(0, 0, 0, 0.65)"
                                 @click="action(item)">
                                禁用
                            </div>
                            <div v-if="item.status == 2" class="card-content-box-footer"
                                 style="background:rgba(24, 144, 255, 0.1);color:#1890FF"
                                 @click="action(item)">
                                已过期
                            </div>
                        </div>
                    </div>
                </div>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next"
                        :total="total">
                </el-pagination>
                <el-dialog
                        :visible.sync="dialogVisible"
                        width="30%">
                    <span>确定要{{status == 0 ? '启动' : '禁用'}}此证书吗？</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="handleAction">确 定</el-button>
                    </span>
                </el-dialog>
            </div>
        </main>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    export default {
        name: "index",
        data() {
            return {
                newId:'',
                inputValue:'',
                currentPage:1,
                pageSize:8,
                total:0,
                informationData:{},
                mainList:[],
                dialogVisible:false,
                status:'',
                dataId:''
            }
        },
        computed:{
            ...mapState({
                id:(state) => state.user.orgId,
                entId:(state) => state.user.userinfo.userId
            })
        },
        created(){
            this.getInfo();
            this.getData();
        },
        methods: {
            // 启动禁用的操作事件
            action(item){
                this.status = item.status;
                this.dataId = item.id;
                this.dialogVisible = true;
            },
            handleAction() {
                if(this.status == 0){
                    this.$http.get('/sys/syscainfo/start?id='+this.dataId).then((res)=>{
                        if(res.data.code == 1){
                            this.dialogVisible = false;
                            this.$notify({
                                title: '启动证书',
                                message: res.data.msg,
                                position: 'bottom-right',
                                type: 'success'
                            });
                            this.getData();
                        }else{
                            this.dialogVisible = false;
                            this.$notify({
                                title: '启动证书',
                                message: res.data.msg,
                                position: 'bottom-right',
                                type: 'warning'
                            });
                        }
                    })
                }else if(this.status == 1){
                    this.$http.get('/sys/syscainfo/disable?id='+this.dataId).then((res)=>{
                        if(res.data.code == 1){
                            this.dialogVisible = false;
                            this.$notify({
                                title: '禁用证书',
                                message: res.data.msg,
                                position: 'bottom-right',
                                type: 'success'
                            });
                            this.getData();
                        }else{
                            this.dialogVisible = false;
                            this.$notify({
                                title: '禁用证书',
                                message: res.data.msg,
                                position: 'bottom-right',
                                type: 'warning'
                            });
                        }
                    })
                }else if(this.status == 2){
                    return
                }
            },
            // 获取企业信息
            getInfo(){
                if(this.id){
                    this.newId =this.id
                    this.$http.post('/tenderer/entbaseinfo/getbyid?id='+this.newId).then((res) => {
                        if(res.data.code && res.data.code == 1){
                            this.informationData = res.data.data;
                        }
                    })
                }else{
                    this.newId =this.entId
                    this.$http.post('/personbaseinfo/getbyid?id='+this.newId).then((res) => {
                        if(res.data.code && res.data.code == 1){
                            this.informationData = res.data.data;
                        }
                    })
                }
            },
            // 获取列表数据
            getData(){
                this.$http.post('/sys/syscainfo/list',{
                    page:this.currentPage,
                    rows:this.pageSize,
                    filter:{
                        userId :this.entId
                    },
                    searchKey: this.inputValue,
                    orderBy:'create_time desc'
                }).then((res) => {
                    if(res.data){
                        this.mainList = res.data.rows;
                        this.total = res.data.total;
                    }
                })
            },
            // 搜索
            serachData(){
                this.currentPage = 1;
                this.getData();
            },
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getData();
            }
        }
    }
</script>

<style lang="scss" scoped>
    header{
        height: 124px;
        background: #fff;
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        .header-title{
         p{
             font-size: 18px;
             font-weight: bold;
             color: #000000;
             line-height: 24px;
             margin-left: 32px;
             padding-top: 20px;
         }
        }
        .header-search{
            display: flex;
            justify-content: center;
            margin-top: 16px;
            .header-search-input{
                width: 482px;
                height: 40px;
                background: #FFFFFF;
                border-radius: 2px;
                outline: none;
            }
            button{
                width: 70px;
                height: 40px;
                background: #1890FF;
                border: none;
                border-radius: 0px 2px 2px 0px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 24px;
                cursor: pointer;
            }
        }
    }
    main{
        padding: 24px;
        .card-item{
            .card-title{
                span{
                    font-size: 16px;
                    color: rgba(0, 0, 0, 0.85);
                }
            }
            .card-content{
                .card-content-allBox{
                    display: flex;
                    flex-wrap: wrap;
                    margin-left: -20px;
                    .card-content-box{
                        width: 377px;
                        height: 326px;
                        margin-left: 24px;
                        .card-content-box-top{
                            width: 378px;
                            height: 105px;
                            background: #F7F7F7;
                            border-radius: 2px 2px 0px 0px;
                            border: 1px solid #EEEEEE;
                            border-bottom: none;
                            display: flex;
                            align-items: center;
                            .card-content-box-top-left{
                                margin-left: 24px;
                                .svg{
                                    width: 48px;
                                    height: 48px;
                                    background: #FFBF00;
                                    border-radius: 50%;
                                    text-align: center;
                                    line-height: 72px;
                                }
                            }
                            .card-content-box-top-right{
                                margin-left: 16px;
                                line-height: 30px;
                                .certificate{
                                    font-size: 16px;
                                    color: rgba(0, 0, 0, 0.85);
                                }
                                .certificate-code{
                                    font-size: 14px;
                                    color: rgba(0, 0, 0, 0.65);
                                }
                            }
                        }
                        .card-content-box-body{
                            width: 378px;
                            height: 201px;
                            background: #FFFFFF;
                            border-radius: 0px 0px 2px 2px;
                            border: 1px solid #EEEEEE;
                            padding: 16px;
                            line-height: 35px;
                            div{
                                display: flex;
                                justify-content: space-between;
                                .title-left{
                                    font-size: 14px;
                                    color: rgba(0, 0, 0, 0.65);
                                }
                                .title-right{
                                    font-size: 14px;
                                    color: rgba(0, 0, 0, 0.45);
                                }
                                .title-right-status-true{
                                    width: 48px;
                                    height: 22px;
                                    background: #ECF5FF;
                                    border-radius: 2px;
                                    border: 1px solid #A3D0FD;
                                    line-height: 22px;
                                    text-align: center;
                                    font-size: 14px;
                                    font-family: PingFangSC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: #1890FF;
                                }
                                .title-right-status-false{
                                    width: 48px;
                                    height: 22px;
                                    background: rgba(212, 0, 0, 0.1);
                                    border-radius: 2px;
                                    opacity: 0.5;
                                    border: 1px solid rgba(212, 0, 0, 0.5);
                                    font-family: PingFangSC-Regular, PingFang SC;
                                    font-size: 14px;
                                    color: #D40000;
                                    line-height: 22px;
                                    text-align: center;
                                }
                            }
                        }
                        .card-content-box-footer{
                            width: 378px;
                            height: 48px;
                            background: #F7F7F7;
                            border-radius: 0px 0px 2px 2px;
                            border: 1px solid #EEEEEE;
                            border-top: none;
                            font-size: 14px;
                            color: rgba(0, 0, 0, 0.65);
                            line-height: 48px;
                            text-align: center;
                            cursor: pointer;
                            opacity: 1 !important;
                        }
                    }
                }
            }
        }
    }
</style>